export const NAME = 'account';
export const UPDATE_ACCOUNT_FORM = 'updateAccountForm';